import { FETCH_PC, UPDATE_PC_STATUS, UPDATE_PC_PIN, VERIFY_PC_PIN, FETCH_PC_ERROR, UPDATE_PC_PIN_ERROR, DISABLE_PC_PIN, DISABLE_PC_PIN_ERROR, VERIFY_PC_PIN_ERROR } from '../actions/types';
import { PC_STATE_OFF } from '../constants';

export function parentControlState(state = PC_STATE_OFF, action) {
    switch (action.type) {
        case FETCH_PC:
            return action.payload;
        case FETCH_PC_ERROR:
            return { ...state, error: action.payload};
        default:
            return state;
    }
}

export function stateChangeSuccess(state = null, action) {
    switch (action.type) {
        case UPDATE_PC_STATUS:
             return (action.payload!==null && action.payload!==false)?true:action.payload;
        default:
            return state;
    }
}

export function pinChangeSuccess(state = {}, action) {
    switch (action.type) {
        case UPDATE_PC_PIN:
            return { error: false, success: action.payload };
        case UPDATE_PC_PIN_ERROR:
            return { error: action.payload, success: false};
        default:
            return state;
    }
}

export function pinDisableSuccess(state = {}, action) {
    switch (action.type) {
        case DISABLE_PC_PIN:
            return { error: false, success: action.payload };
        case DISABLE_PC_PIN_ERROR:
            return { error: action.payload, success: false};
        default:
            return state;
    }
}

export function pinCheckSuccess(state = {}, action) {
    switch (action.type) {
        case VERIFY_PC_PIN:
            return { error: false, success: action.payload };
        case VERIFY_PC_PIN_ERROR:
            return { error: action.payload};
        default:
            return state;
    }
}
